import { DateTime } from 'luxon';
import { Instance, flow, types } from 'mobx-state-tree';

import { createMeet, getMeets, removeMeet } from '@common/api/meets';
import { TIME_ZONE } from '@common/constants/academyReworkings';
import { bookingPayload } from '@common/helpers/academyReworkings';
import { BookedMeet, BookingResult } from '@common/types/academyReworkings';

import fetchAll from './helpers/fetchAll';

const StudentMeets = types
	.model('AcademyStudentMeets', {
		studentId: types.number,
		includeAllTypes: false,
		data: types.optional(types.frozen<BookedMeet[]>(), []),
	})
	.volatile(() => ({ loading: false, saving: false }))
	.actions((self) => {
		let revision = 0;
		return {
			fetch: flow(function* () {
				revision += 1;
				const request = revision;
				self.loading = true;
				try {
					const result: BookedMeet[] = yield fetchAll<BookedMeet>(
						(page, limit) =>
							getMeets({
								service_id: 1,
								...(!self.includeAllTypes && { type: 'working_off' }),
								student_id: self.studentId,
								period_start: DateTime.now().setZone(TIME_ZONE).toISODate(),
								page,
								limit,
							}),
						100,
					);
					if (request === revision) self.data = result;
					return result;
				} finally {
					if (request === revision) self.loading = false;
				}
			}),
			add: flow(function* (payload: ReturnType<typeof bookingPayload>) {
				self.saving = true;
				try {
					const result: BookingResult = yield createMeet(payload);
					return result;
				} finally {
					self.saving = false;
				}
			}),
			remove: flow(function* (id: number) {
				self.saving = true;
				try {
					yield removeMeet(id);
					self.data = self.data.filter((meet) => meet.id !== id);
				} finally {
					self.saving = false;
				}
			}),
		};
	});

export default StudentMeets;
export interface IStudentMeetsModel extends Instance<typeof StudentMeets> {}
